export default "__VITE_ASSET__DT_tSskx__"